import axios from "../../config/axiosConfig";
import {
  CREATE_PURCHASE_CHALLAN, DELETE_PURCHASE_CHALLAN,
  GET_PURCHASE_CHALLANS,
  PURCHASE_CHALLAN_REQUEST,
  PURCHASE_CHALLAN_REQUEST_FAILURE,
  UPDATE_PURCHASE_CHALLAN,
  GET_PURCHASE_CHALLANS_PAGE,
  PURCHASE_CHALLAN_REQUEST_SUCCESS
} from "../types/purchase-challan-types";

export const getPurchaseChallansWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Lot_Id'
      };
      return axios.get("/purchase-challan/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_CHALLANS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseChallanById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
    
      return axios.get(`/purchase-challan/get/${id}`).then((response) => {
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseChallans = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/purchase-challan/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_CHALLANS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createPurchaseChallan = (purchasebill) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
      const newPurchaseChallan = {
        ...purchasebill
      };
      return axios.post("/purchase-challan/add", newPurchaseChallan,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PURCHASE_CHALLAN, payload: response.data });
        } else {
          dispatch({
            type: PURCHASE_CHALLAN_REQUEST_FAILURE,
            error: "Purchase Challan create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/purchase-challan/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_CHALLAN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PURCHASE_CHALLAN_REQUEST_FAILURE,
            error: "Purchase Challan update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePurchaseChallan = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_CHALLAN_REQUEST });
      return axios.delete(`/purchase-challan/delete/${id}`).then( async(response) => {
        if (response.data) {
          dispatch({ type: DELETE_PURCHASE_CHALLAN, id: id });
          const include = ['id', 'Entry_No', 'Challan_No', 'Order_No', 'Bill_Date', 'Book_Id', 'Date', 'Account_Id', 'Lot_Id', 'Net_Total', 'Amount'].join(',');
          const searchCols = ['Entry_No'].join(',');
          const { transaction: { purchaseChallan: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getPurchaseChallansWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getRemianingPurchaseOrdersInChallan = (industryTypeId, id) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        industryTypeId,
        id
      };
      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/purchase-challan/getRemainingPurchaseOrders`, { params }).then((response) => {
        if (response.data) {
          return response.data;
        } else {
          return [];
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};